<template>
    <div class="gallery-btn-cont" :style="{ backgroundColor: selected ? '#e1a732': '#fff'}">
      <div class="gallery-btn-text">{{ title }}</div>
      <img
          class="gallery-btn-icon"
          :src="icon" alt="icon"
          :style="{
            width: iconWidth + 'px',
            height: iconHeight + 'px',
            transform: rotate ? 'rotate(90deg)' : 'rotate(0)'
          }"
        />
    </div>
</template>
<script>
    export default {
        name: 'GalleryButton',
        props: {
            title: {
                type: String,
                default: 'Discover New Music'
            },
            icon: {
                type: String,
                default: require('../assets/image/icon-musicnote.png')
            },
            color: {
                type: String,
                default: '#18c684'
            },
            iconWidth: {
                type: String,
                default: '20'
            },
            iconHeight: {
                type: String,
                default: '20'
            },
            rotate: {
              type: Boolean,
              default: false,
            },
            selected: {
              type: Boolean,
              default: false,
            }
        },
    }
</script>
<style lang="scss">
    @import '~vuetify/src/styles/settings/_variables';
    /* Laptop/Desktop/Default */
    .gallery-btn-cont {
      display: flex;
      flex-direction: row;
      min-width: 186px;
      height: 47px;
      border-radius: 50px;
      justify-content: space-evenly;
      align-items: center;
      padding: 15px;
      object-fit: cover;
      background-image: url("../assets/image/art-texture.png");
    }

    .gallery-btn-text {
      color: black;
      font-size: 17px;
      font-stretch: normal;
      font-family: SSNicksonFour, serif;
      line-height: 1.1;
      margin-top: 4px;
      letter-spacing: 1px;
      margin-right: 4px;
    }

    /* Large Tablet/Laptop size */
    @media #{map-get($display-breakpoints, 'md-and-down')} {
      .gallery-btn-cont {
        min-width: 140px;
        border-radius: 50px;
      }

      .gallery-btn-text {
        font-size: 15px;
        line-height: 1.1;
      }
    }

    /* Mobile */
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
        .gallery-btn-cont {
            width: 160px;
            border-radius: 50px;
        }

        .gallery-btn-text {
            font-size: 12px;
            line-height: 1.1;
        }
    }
</style>